module.exports = "<div class=\"ssf-power\">\n\n    <svg id=\"ico-power-button-circle\" class=\"ssf-power__inner\" aria-hidden=\"true\" viewBox=\"0 0 512 512\"><path d=\"m256 32c-124 0-224 100-224 224c0 124 100 224 224 224c124 0 224-100 224-224c0-124-100-224-224-224z m-19 78c0-11 9-20 20-20c11 0 20 9 20 20l0 124c0 11-9 20-20 20c-11 0-20-9-20-20z m19 288c-79 0-144-64-144-144c0-58 35-108 85-131l0 47c-27 19-44 50-44 84c0 57 46 104 103 104c57 0 103-47 103-104c0-33-16-63-41-81l0-48c48 23 82 72 82 129c0 80-64 144-144 144z\"></path></svg>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/logout/logout.component.html
// module id = 633
// module chunks = 3